import React from 'react';
import { BilingualText } from './BilingualText';
import { CheckCircle2, Clock, Truck, AlertCircle, ChevronRight, QrCode } from 'lucide-react';
export type ShipmentStatus = 'Draft' | 'Pending Approval' | 'Confirmed' | 'Truck Arrived' | 'Check-in' | 'Unloading' | 'Goods Received' | 'Completed' | 'Cancelled';
interface ShipmentCardProps {
  id: string;
  supplierEn: string;
  supplierAr: string;
  status: ShipmentStatus;
  time: string;
  warehouseEn: string;
  warehouseAr: string;
  onClick?: () => void;
}
const statusConfig: Record<ShipmentStatus, {
  color: string;
  icon: any;
  en: string;
  ar: string;
}> = {
  Draft: {
    color: 'bg-slate-100 text-slate-600',
    icon: Clock,
    en: 'Draft',
    ar: 'مسودة'
  },
  'Pending Approval': {
    color: 'bg-yellow-100 text-yellow-700',
    icon: AlertCircle,
    en: 'Pending Approval',
    ar: 'بانتظار الموافقة'
  },
  Confirmed: {
    color: 'bg-blue-100 text-blue-700',
    icon: CheckCircle2,
    en: 'Confirmed',
    ar: 'مؤكد'
  },
  'Truck Arrived': {
    color: 'bg-indigo-100 text-indigo-700',
    icon: Truck,
    en: 'Truck Arrived',
    ar: ''
  },
  'Check-in': {
    color: 'bg-purple-100 text-purple-700',
    icon: QrCode,
    en: 'Check-in',
    ar: 'تسجيل الدخول'
  },
  Unloading: {
    color: 'bg-orange-100 text-orange-700',
    icon: Clock,
    en: 'Unloading',
    ar: 'جاري التفريغ'
  },
  'Goods Received': {
    color: 'bg-teal-100 text-teal-700',
    icon: CheckCircle2,
    en: 'Goods Received',
    ar: 'تم استلام البضائع'
  },
  Completed: {
    color: 'bg-green-100 text-green-700',
    icon: CheckCircle2,
    en: 'Completed',
    ar: 'مكتمل'
  },
  Cancelled: {
    color: 'bg-red-100 text-red-700',
    icon: AlertCircle,
    en: 'Cancelled',
    ar: 'ملغي'
  }
};
export function ShipmentCard({
  id,
  supplierEn,
  supplierAr,
  status,
  time,
  warehouseEn,
  warehouseAr,
  onClick
}: ShipmentCardProps) {
  const config = statusConfig[status];
  const Icon = config.icon;
  return <button onClick={onClick} className="card w-full p-4 text-left hover:border-[#2E3192] transition-colors group" data-id="element-138">
      <div className="flex justify-between items-start mb-3" data-id="element-139">
        <div className="space-y-1" data-id="element-140">
          <span className="text-xs font-bold text-slate-400 uppercase tracking-wider" data-id="element-141">
            #{id}
          </span>
          <BilingualText en={supplierEn} ar={supplierAr} data-id="element-142" />
        </div>
        <div className={`px-3 py-1 rounded-full text-xs font-bold flex items-center gap-1.5 ${config.color}`} data-id="element-143">
          <Icon size={14} data-id="element-144" />
          <span data-id="element-145">{config.en}</span>
        </div>
      </div>

      <div className="flex items-end justify-between pt-2 border-t border-slate-50" data-id="element-146">
        <div className="space-y-1" data-id="element-147">
          <div className="flex items-center gap-2 text-slate-500" data-id="element-148">
            <Clock size={14} data-id="element-149" />
            <span className="text-sm font-medium" data-id="element-150">{time}</span>
          </div>
          <BilingualText en={warehouseEn} ar={warehouseAr} subtle className="text-xs" data-id="element-151" />
        </div>
        <ChevronRight className="text-slate-300 group-hover:text-[#2E3192] transition-colors" size={20} data-id="element-152" />
      </div>
    </button>;
}